module.exports = __webpack_public_path__ + "static/media/datasAPI.e3aa2f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/ApiForBusiness/datasAPI.png
// module id = 46
// module chunks = 0